/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { LandingFAQ } from './model/landingFAQ';

/**
 * Returns fact interpolated FAQs for a given SEO location.
 */
export const apiSeoLocationNeighborhoodFaqsList = (
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LandingFAQ[]>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${language}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/faqs/`,
    method: 'GET',
    signal,
  });
};

export const getApiSeoLocationNeighborhoodFaqsListQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  neighborhood?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${language}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/faqs/`,
  ] as const;
};

export const getApiSeoLocationNeighborhoodFaqsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationNeighborhoodFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationNeighborhoodFaqsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSeoLocationNeighborhoodFaqsListQueryKey(
      countryUrlPrefix,
      language,
      neighborhood,
      city,
      regionSlug,
      seoSlug
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationNeighborhoodFaqsList>>> = ({
    signal,
  }) =>
    apiSeoLocationNeighborhoodFaqsList(
      countryUrlPrefix,
      language,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && language && neighborhood && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSeoLocationNeighborhoodFaqsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiSeoLocationNeighborhoodFaqsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationNeighborhoodFaqsList>>
>;
export type ApiSeoLocationNeighborhoodFaqsListQueryError = ErrorType<unknown>;

export function useApiSeoLocationNeighborhoodFaqsList<
  TData = Awaited<ReturnType<typeof apiSeoLocationNeighborhoodFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationNeighborhoodFaqsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationNeighborhoodFaqsListQueryOptions(
    countryUrlPrefix,
    language,
    neighborhood,
    city,
    regionSlug,
    seoSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
